import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "warehouse-to-warehouse",
  value: "Warehouse_To_Warehouse_Transfer",
  labelKey: "inventory.transferWarehouseToWarehouse",
  party: "warehouse",
};

export function WarehouseToWarehouseTransferModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
